module.exports = __webpack_public_path__ + "static/img/teaching_1.889a4c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/teaching_1.png
// module id = 2ul2
// module chunks = 0